module.exports = __webpack_public_path__ + "static/media/2m.60fedd85.png";